import Marquee from 'react-fast-marquee';

const MarqueeStrip = () => {
    const words = ['Decades of trust', 'Uncompromised quality', 'EN1A · EN8 · EN19 · EN24 · SS304 · SS316', 'ISO 9001:2015', 'Since 1985'];
    return (
        <section data-testid="marquee-strip" className="marquee-wrap bg-[#0A0A0B] text-white border-y border-white/10 py-6 md:py-8 overflow-hidden">
            <Marquee gradient={false} speed={40} pauseOnHover>
                {words.map((w, i) => (
                    <span key={i} className="mx-10 md:mx-14 inline-flex items-center gap-10 md:gap-14">
                        <span
                            className="h-display text-[42px] md:text-[80px] text-transparent"
                            style={{
                                WebkitTextStroke: '1px rgba(255,255,255,0.9)',
                            }}
                        >
                            {w}
                        </span>
                        <span className="text-[#FF3B00] text-3xl md:text-5xl">✱</span>
                    </span>
                ))}
            </Marquee>
        </section>
    );
};

export default MarqueeStrip;
